import React, { useState } from 'react'

import { BUY_ME_A_COFFEE_URL } from './Feedback'

export default function Banner() {
  const [isDismissed, setIsDismissed] = useState(false)

  const openInNewTab = (): void => {
    const newWindow = window.open(
      BUY_ME_A_COFFEE_URL,
      '_blank',
      'noopener,noreferrer'
    )
    if (newWindow) newWindow.opener = null
  }

  const handleDismiss = (e: React.MouseEvent): void => {
    e.stopPropagation()
    setIsDismissed(true)
  }

  if (isDismissed) {
    return null
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#4f46e5',
        height: 50,
        cursor: 'pointer',
        color: 'white',
        position: 'relative',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            boxShadow: '5px 5px 1px #000000',
            paddingLeft: 10,
            paddingRight: 10,
            borderRadius: 10,
            height: 30,
            color: '#4f46e5',
            fontSize: 20,
            cursor: 'pointer',
          }}
          onClick={() => openInNewTab()}
        >
          {'Buy me a coffee!'}
        </div>
        <a
          href="https://jtarcade.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{
            color: 'white',
            fontSize: 16,
            fontWeight: 600,
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Checkout my other games!
        </a>
      </div>
      <button
        onClick={handleDismiss}
        style={{
          position: 'absolute',
          right: 10,
          background: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: 24,
          cursor: 'pointer',
          padding: 5,
          lineHeight: 1,
        }}
        aria-label="Dismiss banner"
      >
        ×
      </button>
    </div>
  )
}
